import { Component, Input } from "@angular/core";
import { environment as env } from "../../../../environments/environment";

@Component({
    selector: "download-link",
    templateUrl: "./download-link.component.html",
})
export class DownloadLinkComponent {
    @Input() public urlPath: string;
    @Input() public linkId: string;

    public get downloadLink() {
        return `${env.apiPath}/files/${this.urlPath}/${this.linkId}`;
    }
}
